import { createApp } from 'vue'
import App from './App.vue'
import 'amfe-flexible'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'

<script>

</script>




createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
